/**
 * Shared Material React Table toolbar layout for management console list pages.
 * Stacks title + primary action on narrow screens and widens the global search field.
 */

export const mrtManagementTableCustomActionsOuterSx = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  gap: { xs: 1.5, sm: 2 },
  flexWrap: { xs: "nowrap", sm: "wrap" },
  p: { xs: 0.5, sm: 1 },
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
};

/** Primary CTA in the custom toolbar (Add / Create …) */
export const mrtManagementTablePrimaryActionButtonSx = {
  ml: { xs: 0, sm: 2 },
  alignSelf: { xs: "stretch", sm: "auto" },
  width: { xs: "100%", sm: "auto" },
  borderRadius: 2.5,
  textTransform: "none",
  fontWeight: 700,
  px: 3,
};

/**
 * Spread into useMaterialReactTable({ ... }).
 * Targets MRT TopToolbar DOM: alert Collapse, toolbar drop zone, then main flex row.
 */
export const mrtManagementTableToolbarOptions = {
  muiSearchTextFieldProps: {
    sx: (theme) => ({
      minWidth: 0,
      width: { xs: "100%", sm: 240 },
      maxWidth: { xs: "100%", sm: 400 },
      alignSelf: { xs: "stretch", sm: "center" },
    }),
  },
  muiTopToolbarProps: {
    sx: (theme) => ({
      [theme.breakpoints.down("sm")]: {
        // Main row: custom actions | search + toolbar icons (MRT_TopToolbar.tsx;
        // direct children: alert Collapse, drop-zone Fade, then this flex row).
        "& > div:nth-child(3)": {
          flexDirection: "column",
          alignItems: "stretch",
          gap: theme.spacing(1),
        },
        "& > div:nth-child(3) > div:last-of-type": {
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          maxWidth: "100%",
          flexWrap: "wrap",
        },
      },
    }),
  },
};
